import { LOG_IN, LOG_OUT, REGISTER, GET_MY_PROFILE } from './auth.types';

export const authActions = {
  logIn: (credentials) => ({
    type: LOG_IN,
    payload: credentials,
  }),
  logOut: () => ({
    type: LOG_OUT,
  }),
  register: (data) => ({
    type: REGISTER,
    payload: data,
  }),
  getMyProfile: () => ({
    type: GET_MY_PROFILE,
  }),
};
